import { Link } from "react-router-dom";
import { ArrowUpRight, Target, Mail } from "lucide-react";
import { BOOKING_URL, AGENCY_EMAIL } from "@/lib/api";
import { Container } from "@/components/kit";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-navy-900">
    <Container className="py-16 md:py-20">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Link to="/" className="flex items-center gap-2.5 w-fit">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gold text-navy-900">
              <Target className="h-5 w-5" strokeWidth={2.4} />
            </span>
            <span className="font-display text-lg font-semibold tracking-tight text-white">
              ICP<span className="text-gold">Matters</span>
            </span>
          </Link>
          <p className="mt-5 max-w-sm text-white/55 leading-relaxed">
            An experimental outbound growth lab. We engineer qualified, ICP-matched B2B meetings —
            and only charge when they actually convert.
          </p>
          <a
            href={`mailto:${AGENCY_EMAIL}`}
            data-testid="footer-email"
            className="mt-6 inline-flex items-center gap-2 font-mono-jb text-sm text-gold hover:text-white transition-colors"
          >
            <Mail className="h-4 w-4" />
            {AGENCY_EMAIL}
          </a>
        </div>

        <div>
          <p className="font-mono-jb text-xs tracking-[0.24em] uppercase text-white/40">Navigate</p>
          <ul className="mt-5 space-y-3">
            {[
              { label: "Home", to: "/" },
              { label: "Services", to: "/services" },
              { label: "About", to: "/about" },
              { label: "Insights", to: "/blog" },
              { label: "Contact", to: "/contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-white/60 hover:text-gold transition-colors duration-300"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-mono-jb text-xs tracking-[0.24em] uppercase text-white/40">Get Started</p>
          <p className="mt-5 text-white/60 leading-relaxed">
            Stop paying for activity. Start paying for outcomes.
          </p>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-cta"
            className="group mt-5 inline-flex items-center gap-2 text-white font-semibold hover:text-gold transition-colors"
          >
            Book A Discovery Call
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="font-mono-jb text-xs text-white/40">
          © {new Date().getFullYear()} ICP Matters — Appointment Lab. All rights reserved.
        </p>
        <p className="font-mono-jb text-xs text-white/40 tracking-wide">
          Pay-for-performance · Qualified · Attended · ICP-Matched
        </p>
      </div>
    </Container>
  </footer>
);
